import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { typeMapToText } from '@/common/enums/discount-type';
export default {
  name: 'discount-list',
  props: {
    projectExtendVO: {
      type: Object,
      value: {}
    },
    promotional: {
      type: Object,
      value: {}
    },
    isGameProject: {
      type: Boolean,
      value: false
    },
    performanceLabelVO: {
      type: Object,
      value: {}
    },
    isCalendarPage: {
      type: Boolean,
      value: false
    },
    groupInfo: {
      type: Object,
      value: null
    },
    promotionVO: {
      type: Object,
      value: null
    },
    useNewStyle: {
      type: Boolean,
      value: false
    },
    isRecommand: {
      type: Boolean,
      value: false
    }
  },
  data: function data() {
    return {
      typeMapToText: typeMapToText
    };
  },
  computed: {
    singleTicketId: function singleTicketId() {
      return this.projectExtendVO.maxDiscSingleTicketId && this.hasSaleLabel;
    },
    setTicketId: function setTicketId() {
      return this.projectExtendVO.maxDiscSetTicketId && this.hasSaleLabel;
    },
    assembleTicketId: function assembleTicketId() {
      return this.projectExtendVO.maxDiscAssembleTicketId && this.hasSaleLabel;
    },
    assembleValue: function assembleValue() {
      return this.projectExtendVO.maxDiscAssembleValue;
    },
    assembleTicketPrice: function assembleTicketPrice() {
      return this.projectExtendVO.maxDiscAssembleTicketPrice;
    },
    assemblePrice: function assemblePrice() {
      return this.projectExtendVO.maxDiscAssemblePrice;
    },
    setValue: function setValue() {
      return this.projectExtendVO.maxDiscSetValue;
    },
    setTicketPrice: function setTicketPrice() {
      return this.projectExtendVO.maxDiscSetTicketPrice;
    },
    ticketSetNumber: function ticketSetNumber() {
      return this.projectExtendVO.maxDiscTicketSetNumber;
    },
    setTicketSellPrice: function setTicketSellPrice() {
      return this.projectExtendVO.maxDiscSetTicketSellPrice;
    },
    singleValue: function singleValue() {
      return this.projectExtendVO.maxDiscSingleValue;
    },
    singleTicketPrice: function singleTicketPrice() {
      return this.projectExtendVO.maxDiscSingleTicketPrice;
    },
    singleTicketSellPrice: function singleTicketSellPrice() {
      return this.projectExtendVO.maxDiscSingleTicketSellPrice;
    },
    isSupportWenhui: function isSupportWenhui() {
      return this.promotional && this.promotional.supportWenhui;
    },
    hasSaleLabel: function hasSaleLabel() {
      return [2, 3].includes(this.performanceLabelVO.saleLabel);
    }
  }
};